import { render } from "./TwoColumns.vue?vue&type=template&id=03b62cb6&scoped=true"
import script from "./TwoColumns.vue?vue&type=script&lang=js"
export * from "./TwoColumns.vue?vue&type=script&lang=js"

import "./TwoColumns.vue?vue&type=style&index=0&id=03b62cb6&scoped=true&lang=css"
import "./TwoColumns.vue?vue&type=style&index=1&id=03b62cb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b62cb6"]])

export default __exports__